import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { BusinessInfo } from '@app/model/business-info';
import { BusinessMediaInfo } from '@app/model/business-media-info';
import { User } from '@app/model/user';
import { BusinessDetailsService } from '@app/services/BusinessDetails/businessDetails.service';
import { LoaderService } from '@app/services/loader/loader.service';
import { UserService } from '@app/services/User/user.service';

@Component({
  selector: 'app-location-details',
  templateUrl: './location-details.component.html',
  styleUrls: ['./location-details.component.scss']
})
export class LocationDetailsComponent implements OnChanges {
  businessUser:any;
  businessInfo: any;
  businessMedia:any;
  @Input() userInfoId: string | undefined;

  emailShow = 7;
  phoneShow = 5;

  constructor(private businessInfoService: BusinessDetailsService,
              private userService: UserService,
              private loader: LoaderService) { 
                this.businessInfo = new BusinessInfo();
                this.businessMedia = new BusinessMediaInfo();
                this.businessUser = new User();
              }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['userInfoId']?.currentValue) {
      this.getBusinessUserById();
      this.getBusinessInfoById();
      this.getBusinessMediaInfoById();
    }
  }

  getBusinessInfoById(): void{
    this.loader.show();
    this.businessInfoService.getBusinessInfoByUUId(this.userInfoId)
    .subscribe({
      next: (res:any) => {
        this.businessInfo = res as BusinessInfo;
        const data = res?.data?.[0];
        if (res.success !== 0 && data) {
          this.businessInfo.userInfoId = data.userInfoId || '';
          this.businessInfo.gender = data.gender;
          this.businessInfo.firstName = data.firstName;
          this.businessInfo.lastName = data.lastName;
          this.businessInfo.businessName = data.businessName;
          this.businessInfo.phoneNumber = data.phoneNumber;
          this.businessInfo.businessWebsite = data.businessWebsite;
          this.businessInfo.detailAddress = data.detailAddress;
          this.businessInfo.businessCity = data.businessCity;
          this.businessInfo.googleLongitude = data.googleLongitude;
          this.businessInfo.googleLatitude = data.googleLatitude;
          this.businessInfo.businessKeywords = data.businessKeywords;
        } else {
          this.businessInfo.userInfoId = '';
          this.businessInfo.gender = "";
          this.businessInfo.firstName = "";
          this.businessInfo.lastName = "";
          this.businessInfo.businessName = "";
          this.businessInfo.phoneNumber = "";
          this.businessInfo.businessWebsite = "";
          this.businessInfo.detailAddress = "";
          this.businessInfo.businessCity = "";
          this.businessInfo.googleLongitude = "";
          this.businessInfo.googleLatitude = "";
          this.businessInfo.businessKeywords = "";
        }
      }
    })  
  }
  
  getBusinessMediaInfoById(): void{
    this.loader.show();
    this.businessInfoService.getMediaInfoByUUId(this.userInfoId)
    .subscribe({
      next: (res:any) => {
        this.businessMedia = res as BusinessMediaInfo;
        const data = res?.data?.[0];
        if (res.success !== 0 && data) {
          this.businessMedia.userInfoId = data.userInfoId;
          this.businessMedia.facebookURL = data.facebookURL;
          this.businessMedia.twitterURL = data.twitterURL;
          this.businessMedia.instagramURL = data.instagramURL;
          this.businessMedia.youTubeURL = data.youTubeURL;
        } else {
          this.businessMedia.userInfoId = "";
          this.businessMedia.facebookURL = "";
          this.businessMedia.twitterURL = "";
          this.businessMedia.instagramURL = "";
          this.businessMedia.youTubeURL = "";
        } 
      },
      // error: (e) => console.error('Error loading business media details.', e),
      // complete:() => {
      //   setTimeout(() => {
      //     this.loader.hide();

      //   }, 1000);
      //   console.log('Loaded business media data from the API.')
      // }
    }
  )  
  }

  getBusinessUserById(): void{
    this.loader.show();
    this.userService.getById(this.userInfoId)
    .subscribe({
      next: (res:any) => {
        this.businessUser = res as User;
        const data = res?.data?.[0];
        if (res.success !== 0 && data) {
          this.businessUser.id = data.userInfoId;
          this.businessUser.user_name = data.userName;
        } else {
          this.businessUser.id = '';
          this.businessUser.user_name = '';
        }  
      }
    }
  )
  }

}
